'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/*!
 * Linkifier Component
 * Copyright 2017 Pedro Ladaria <pedro.ladaria@gmail.com>
 * License: MIT
 */
var React = require('react');
var RE_URL = require('./regexp-url.js');
var RE_EMAIL = require('./regexp-email.js');
var RE_HAS_SCHEME = /^\w+:/i;

var DEFAULT_PROTOCOL = 'http';

var getKey = function getKey(n) {
    return 'l' + n;
};

var addProtocolIfNeeded = function addProtocolIfNeeded(url) {
    var protocol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_PROTOCOL;

    if (RE_EMAIL.test(url)) {
        return 'mailto:' + url;
    }
    if (RE_HAS_SCHEME.test(url)) {
        return url;
    }
    return protocol + '://' + url;
};

var braces = '() [] {} <> ¿? ¡! «» “” ** __ ~~ "" \'\' ``'.split(' ');

var RE_SPLIT = /(\s+|[.,;:]\s|[.,;:]$)/;

var split = exports.split = function split(s) {

    var result = [];

    s.split(RE_SPLIT).forEach(function (part) {
        if (part.length < 3 || /[a-zA-Z0-9]/.test(part[0])) {
            result.push(part);
            return;
        }

        var depth = 0;
        var length = part.length;
        var open = [];
        var close = [];

        while (length > (1 + depth) * 2) {
            var _s = part[depth];
            var e = part[length - depth - 1];
            var i = void 0;
            for (i = 0; i < braces.length; i++) {
                if (_s === braces[i][0] && e === braces[i][1]) {
                    open.push(braces[i][0]);
                    close.push(braces[i][1]);
                    depth++;
                    break;
                }
            }
            if (i >= braces.length) {
                break;
            }
        }

        if (depth) {
            result.push(open.join(''), part.substr(depth, length - depth * 2), close.reverse().join(''));
        } else {
            result.push(part);
        }
    });

    return result;
};

var linkifier = function linkifier(text) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var _ref$renderer = _ref.renderer,
        renderer = _ref$renderer === undefined ? 'a' : _ref$renderer,
        protocol = _ref.protocol,
        props = _objectWithoutProperties(_ref, ['renderer', 'protocol']);

    var result = [];
    var parts = split(text);
    var acc = [];
    var key = 0;
    var pushAccumulated = function pushAccumulated() {
        if (acc.length) {
            result.push(React.createElement('span', { key: getKey(key++) }, acc.join('')));
        }
        acc = [];
    };

    parts.forEach(function (part) {
        if (!part) {
            return;
        }
        if (RE_URL.test(part)) {
            pushAccumulated();
            props.href = addProtocolIfNeeded(part, protocol);
            props.key = getKey(key++);
            result.push(React.createElement(renderer, props, part));
        } else {
            acc.push(part);
        }
    });
    pushAccumulated();
    return result;
};

exports.linkifier = linkifier;
var DEFAULT_IGNORED = ['a', 'button'];

var Linkifier = function (_React$Component) {
    _inherits(Linkifier, _React$Component);

    /**
     * @typedef Props
     * @property {React.DOMElement[]} ignore
     * @property {string} href
     * @property {React.DOMElement} renderer
     * @property {string} protocol
     *
     * @param {Props} props
     */
    function Linkifier(props) {
        _classCallCheck(this, Linkifier);

        var _this = _possibleConstructorReturn(this, (Linkifier.__proto__ || Object.getPrototypeOf(Linkifier)).call(this, props));

        _this.keyIndex = 0;
        return _this;
    }

    _createClass(Linkifier, [{
        key: 'linkify',
        value: function linkify(node, ignore, props) {
            var _this2 = this;

            if (typeof node === 'string') {
                return linkifier(node, props);
            }
            if (Array.isArray(node)) {
                return node.map(function (n) {
                    return _this2.linkify(n, ignore, props);
                });
            }
            if (node && ignore.indexOf(node.type) >= 0) {
                return node;
            }
            if (React.isValidElement(node)) {
                return React.cloneElement(node, { key: getKey(++this.keyIndex) }, this.linkify(node.props.children, ignore, props));
            }
            return node;
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                children = _props.children,
                _props$ignore = _props.ignore,
                ignore = _props$ignore === undefined ? [] : _props$ignore,
                props = _objectWithoutProperties(_props, ['children', 'ignore']);

            if (React.Children.count(children) === 0) {
                return null;
            }

            var result = this.linkify(React.Children.toArray(children), ignore, props);

            if (result.length === 1 && React.isValidElement(result[0])) {
                return result[0];
            }

            return result;
        }
    }]);

    return Linkifier;
}(React.Component);

Linkifier.defaultProps = {
    ignore: DEFAULT_IGNORED
};

Linkifier.DEFAULT_IGNORED = DEFAULT_IGNORED;

exports.default = Linkifier;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-linkifier/dist/linkifier.js
// module id = 164
// module chunks = 0